module.exports = __webpack_public_path__ + "static/media/party.fc1e0280.jpg";